export const handleUnauthorizedResponse = () => {
  window.dispatchEvent(new CustomEvent('user:force-logout'));
};

export const handleGenericTechnicalError = () => {
  throw new Error('Something bad happened; please try again later.');
};
